const PREFIX = '/v1/CollectiveProject/ZhengbuProjectOldInfoService'

export const URL = {
  ADD: PREFIX + '/add',
  DEL: PREFIX + '/delete',
  EDIT: PREFIX + '/edit',
  LIST: PREFIX + '/list',
  DETAIL: PREFIX + '/view',
  ENABLE: PREFIX + '/able',
  DISABLE: PREFIX + '/disable',
  ORDER: PREFIX + '/order',
  EXPORT: PREFIX + '/export'
}
